import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 80,
    paddingInline: theme.palette.custom.lgPaddingInline,
    overflow: 'hidden',
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
    background: '#f5f5f5',
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  list: {
    paddingInlineEnd: 20,
  },
  title: {
    '& .MuiTypography-root': {
      color: theme.palette.custom.main,
      paddingBlockEnd: 20,
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
  },
  label: {
    '& .MuiTypography-root': {
      paddingBlockEnd: 12,
      cursor: 'pointer',
      color: '#656565',
    },
  },
  labelIconImg: {
    width: 20,
    height: 20,
  },
  labelLink: {
    fontSize: 18,
    textDecoration: 'none',
    color: '#656565',
    // paddingBlockEnd: 12,
  },
  linkWrapper: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
  },
  socialIcons: {
    width: 28,
    height: 28,
    cursor: 'pointer',
  },
  copyright: {
    background: '#000',
    paddingBlock: 12,
    '& .MuiTypography-root': {
      textAlign: 'center',
      color: '#fff',
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
  },
}))

export default useStyles
